import React from 'react';
import { TabScrollButton } from '@mui/material';
import TabLabelIcon from '@/components/TabLabel/TabLabelIcon';
import styles from './TabsScroller.module.scss';

const getCoord = (node, coord) => node.getBoundingClientRect()[coord];

interface TabsScrollerProps {
  disabled: boolean;
  invalidTabs: { position: number }[];
  onClick: () => void;
  direction: 'left' | 'right';
  containerId: string;
}

const TabsScroller: React.FC<TabsScrollerProps> = (props) => {
  const { disabled, invalidTabs, onClick, containerId = '' } = props;
  const tabsViewer = document.querySelector(`${containerId ? `#${containerId}` : ''} .MuiTabs-scroller.MuiTabs-scrollableX`);
  const tabs = tabsViewer ? [...(tabsViewer.querySelector(`${containerId ? `#${containerId}` : ''} .MuiTabs-flexContainer`)?.children ?? [])] : [];

  const getVisibleTabs = () => {
    let firstTab = tabs.length;
    let lastTab = 0;

    for (let i = 0; i < tabs.length; i++) {
      if (getCoord(tabsViewer, 'x') <= getCoord(tabs[i], 'x')) {
        firstTab = Math.min(firstTab, i);
      }

      if (getCoord(tabsViewer, 'right') >= getCoord(tabs[i], 'right')) {
        lastTab = Math.max(lastTab, i);
      }
    }

    return [firstTab, lastTab];
  };

  const getWarningClass = () => {
    const visibleTabs = getVisibleTabs();
    const showWarning = (props.direction === 'left' && visibleTabs[0] > invalidTabs[0].position)
      || (props.direction === 'right' && visibleTabs[1] < invalidTabs[invalidTabs.length - 1].position);

    return showWarning ? styles.Warning : '';
  };

  return (
    <div className={`${styles.TabsScroller} ${disabled ? styles.Disabled : ''} ${getWarningClass()}`} onClick={onClick}>
      <TabLabelIcon extraClass={styles.Icon} />
      <TabScrollButton disabled={disabled} onClick={onClick} direction={props.direction} orientation='horizontal' />
    </div>
  );
};

export default TabsScroller;
